export type CustomEventNamesType = 'shift-calendar-filters-updated';

export const prefixEventKey = (eventKey: CustomEventNamesType) =>
  `works:${eventKey}`;

export function runCustomEvent(eventName: CustomEventNamesType) {
  window.dispatchEvent(new CustomEvent(prefixEventKey(eventName)));
}
